export const scrollToElement = (elementId: string) => {
    const nextStep = document.getElementById(elementId)
    if (nextStep) {
        nextStep.scrollIntoView({ behavior: "smooth" })
    } else {
        window.scrollTo({ behavior: "smooth", left: 0, top: 0 })
    }
}
